export const addMinutes = (time: string, delta: number) => {
  const [hours, minutes] = time.split(":").map((v) => parseInt(v, 10));
  const totalMinutes = hours * 60 + minutes + delta;
  return `${Math.floor(totalMinutes / 60)
    .toString()
    .padStart(2, "0")}:${(totalMinutes % 60).toString().padStart(2, "0")}`;
};
